import request from "@/utils/myRequest";

// 获取语言列表
export function getLanguageList() {
	return request("language_list", {}, "get");
}

// 获取头部导航
export function getNavList(data) {
	return request("navigation_list", data, "get");
}

// 首页信息
export function getIndexInfo() {
	return request("home_info", {}, "get");
}

// 通用单页
export function getPageInfo(data) {
	return request("global_template", data, "get");
}
// 女性脱发
export function getInfo1() {
	return request("info_female_hair_loss", {}, "get");
}
// 男性脱发
export function getInfo2() {
	return request("info_male_hair_loss", {}, "get");
}
// 开始
export function getInfo3() {
	return request("info_start", {}, "get");
}
// 信息与头发生物学
export function getInfo4() {
	return request("info_hair_biology", {}, "get");
}
// 脱发原因
export function getInfo5() {
	return request("info_hair_loss_causes", {}, "get");
}
// 如何了解
export function getInfo6() {
	return request("info_how_to_understand", {}, "get");
}
// 成分和技术
export function getInfo7() {
	return request("info_compositionAnd_technology", {}, "get");
}
// 视频
export function getInfo8() {
	return request("info_video", {}, "get");
}

// 成功故事
export function getStoryInfo() {
	return request("success_story_info", {}, "get");
}

// 常见问题
export function getProblemInfo() {
	return request("common_problem_info", {}, "get");
}

// 媒体
export function getMediaInfo() {
	return request("media_info", {}, "get");
}

// 网站信息
export function getwebInfo() {
	return request("company_info", {}, "get");
}
